import { render } from "./LinkView.vue?vue&type=template&id=e5357308"
import script from "./LinkView.vue?vue&type=script&lang=js"
export * from "./LinkView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__